<script>
export default {
	inheritAttrs: false
};
</script>

<script setup>
import { ref, watch } from "vue";

const props = defineProps(["src"]);
defineEmits(["load"]);

const loading = ref(true);

watch(() => props.src, () => {
	loading.value = true;
});
</script>

<template>
	<div class="vui-iframe">
		<iframe
			v-bind="$attrs"
			:src="src"
			@load="loading = false; $emit('load', $event)"
		></iframe>
		<div v-if="loading" class="iframe-loading">
			<i class="fa-regular fa-xl fa-spin fa-spinner-third"></i>
		</div>
	</div>
</template>
